import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import P from '@deliveroo/consumer-component-library/components/P';
import { ACTION_BOTTOM_SHEET } from '../../containers/OrderHelpTemplateContainer/templateTypes';

import ModalFooter from '../ModalFooter';

/**
 * A generic dynamic actions template to render the actions as a bottom sheet in mobile view.
 */
function OrderHelpTemplateActionsBottomSheet({
  actionId,
  data: { message, actions },
  iframe,
  hideFooterPrevious,
  requestInteraction,
}) {
  const onSubmit = () => {
    requestInteraction({
      parentActionId: actionId,
      parentActionTemplate: ACTION_BOTTOM_SHEET,
      templateData: {},
    });
  };

  const submitAction = actions && actions.filter((action) => action.type === 'submit')[0];

  return (
    <Fragment>
      <P spacing={`0 ${iframe ? 'x-large' : 'medium'}`}>{message}</P>

      <ModalFooter
        buttonType={submitAction.style}
        modal={iframe}
        onSubmit={onSubmit}
        cta={submitAction.text}
        hidePrevious={hideFooterPrevious}
      />
    </Fragment>
  );
}

OrderHelpTemplateActionsBottomSheet.propTypes = {
  /**
   * Which help screen the template is currently on.
   */
  actionId: PropTypes.string.isRequired,
  /**
   * Whether to style the template appropriately for a modal.
   */
  iframe: PropTypes.bool.isRequired,
  /**
   * Whether to hide the previous button for the footer
   */
  hideFooterPrevious: PropTypes.bool,
  /**
   * The dispatch action that will be triggered onClick for each OrderHelpActionRows.
   * This will be used to update the dynamic action and grab the next self help page
   */
  requestInteraction: PropTypes.func.isRequired,
  /**
   * Data object for the template which comes from dynamic actions
   */
  data: PropTypes.shape({
    message: PropTypes.string,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        style: PropTypes.string,
        text: PropTypes.string,
      }),
    ),
  }),
};

OrderHelpTemplateActionsBottomSheet.defaultProps = {
  data: {},
  hideFooterPrevious: true,
};

export default OrderHelpTemplateActionsBottomSheet;
